export default __webpack_public_path__ + "static/media/IV-2021.e6f4e043.pdf";